import { IconChevronRight, IconExclamation, IconInfo } from '@lib/icons'
import cx from 'classnames'
import type { FC, PropsWithChildren } from 'react'

import { WarningIconType } from '@/types'
import type OnlyOneOf from '@/utils/types/OnlyOneOf'
import css from './Warning.module.scss'

type Props = {
  className?: string
  iconType: WarningIconType
  text: string
} & OnlyOneOf<
  {
    actionFn: () => void
  },
  {
    url: string
  }
>

export const Warning: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  iconType,
  url,
  actionFn,
  text,
}) => {
  const handleClick =
    actionFn ||
    (() => {
      window.open(url!, '_blank')
    })

  return (
    <div className={cx(css.container, className)}>
      <div className={css.body}>
        {iconType === WarningIconType.EXCLAMATION && (
          <IconExclamation className={css.icon} />
        )}
        {iconType === WarningIconType.INFO && (
          <IconInfo size={16} className={css.icon} />
        )}
        {children}
      </div>
      <div className={css.link} onClick={handleClick}>
        <p>
          <span>{text}</span> <IconChevronRight />
        </p>
      </div>
    </div>
  )
}
